export default "__VITE_ASSET__gFgYakM8__"